import { config } from "@app-contexts/sdk/services/config";
import { Widget, WidgetQueryParams } from "@app-contexts/sdk/services/Widget";

// handlers are dependent on each other - checkout listener needs calendar
// and calendar needs checkout
// eslint-disable-next-line import/no-cycle
import { calendarWidget } from "./calendar";

/**
 * Widget to show the checkout flow only
 * @param params values to add to URL params (e.g. 'theme-primary', 'theme-secondary', etc.)
 * @param containerId id of the container to embed the widget in
 */
export async function checkoutWidget(
  params: WidgetQueryParams,
  containerId?: string
) {
  const widget = new Widget({
    src: await config.checkoutWidgetUrl(),
    queryParams: params,
    containerId,
  });

  widget
    .on("showpass.checkout.close", () => {
      if (containerId) {
        window.parent.postMessage("showpass.calendar.remount", "*");
      }
    })
    .show()
    .on("showpass.checkout.back-to-event", ({ slug, params }) => {
      eventPurchaseWidget(slug, params);
    });

  return widget;
}

/**
 * Shows the express checkout widget
 * @param params values to add to URL params (e.g. 'theme-primary', 'theme-secondary', etc.)
 * @param containerId id of the container to embed the widget in
 */
export async function expressCheckoutWidget(
  params: WidgetQueryParams,
  containerId?: string
) {
  const widget = new Widget({
    src: await config.expressCheckoutWidgetUrl(),
    queryParams: params,
    containerId,
  });

  widget.show();

  return widget;
}

/**
 * Shows an event purchase widget for the specified event
 * @param slug slug of event
 * @param params values to add to URL params (e.g. 'theme-primary', 'theme-secondary', etc.)
 * @param containerId id of the container to embed the widget in
 */
export async function eventPurchaseWidget(
  slug = "",
  params: WidgetQueryParams = {},
  containerId?: string
) {
  const widget = new Widget({
    src: await config.eventPurchaseWidgetUrl(slug),
    containerId,
    queryParams: {
      ...params,
      "theme-primary": params["theme-primary"],
      "theme-secondary": params["theme-secondary"] || params["theme-primary"],
    },
  });

  widget
    .show()
    .on("showpass.event-purchase.close", () => {
      if (containerId) {
        window.parent.postMessage("showpass.calendar.remount", "*");
      }
      widget.close();
    })
    .on("showpass.event-purchase.back-to-calendar", ({ venueId, params }) => {
      calendarWidget(venueId, params);
    })
    .on("showpass.event-purchase.checkout", () => {
      widget.close({ removeBodyClass: false });
      checkoutWidget(params);
    })
    .on("showpass.event-purchase.express-checkout", () => {
      widget.close({ removeBodyClass: false });
      expressCheckoutWidget(params);
    });

  return widget;
}
